
/**
 * Parse the original search query and extract date components via smart-date-recognizer.
 * Returns the raw recognizer payload alongside the flattened fields so downstream
 * pattern generation does not have to re-run recognizeDate.
 *
 * @param {string} queryOriginal - The raw user query
 * @returns {{ query: string, dateFromQuery: string|null, dateToQuery: string|null, dateVariants: Array|null, usedTokens: any|null, recognized: Object|null }}
 */
export function parseDateFromQuery(queryOriginal) {
    let query = queryOriginal;
    let dateFromQuery = null;
    let dateToQuery = null;
    let dateVariants = null;
    let usedTokens = null;
    let recognized = null;

    try {
        if (typeof window.recognizeDate === 'function') {
            recognized = window.recognizeDate(queryOriginal || '') || null;
            if (recognized) {
                usedTokens = recognized.usedTokens || null;
                if (recognized.variants && Array.isArray(recognized.variants) && recognized.variants.length > 0) {
                    query = pickStrippedQuery(recognized.strippedQuery, queryOriginal);
                    dateVariants = recognized.variants;
                } else if (recognized.from || recognized.to) {
                    query = pickStrippedQuery(recognized.strippedQuery, queryOriginal);
                    dateFromQuery = recognized.from || null;
                    dateToQuery = recognized.to || null;
                }
            }
        }
    } catch(_) {}

    return { query, dateFromQuery, dateToQuery, dateVariants, usedTokens, recognized };
}

function pickStrippedQuery(stripped, queryOriginal) {
    const sTrim = (typeof stripped === 'string') ? stripped.trim() : '';
    const qOrig = (typeof queryOriginal === 'string') ? queryOriginal : '';
    return (sTrim || qOrig).trim();
}
